import { css } from "@nodusjs/std/dom";

export const style = () =>
  css`
    :host {
      box-sizing: border-box;
      display: block;
    }

    :host(:state(hidden)) {
      display: none;
    }
  `;
